// @flow

import { dispatch } from 'redux/store'
import { setVars } from 'redux/action'
import { get } from './lib/apiClient'
import * as analysis from 'frame/core/analysis'
import fengPerf from 'feng-performance'
import { decrypt } from 'frame/core/cryptoAes'

export function fetchVisitor () {
  return get('/user/getInfo?withCredit=1')
    .then(function (visitor) {
      return visitor
    })
    .then(visitor => {
      if (visitor.isLogin) {
        analysis.setUid(visitor.id)
        analysis.setCustomVar('isLogin', visitor.isLogin)
        fengPerf.Performance.setUid(visitor.id)
        return get('/v2/common/backendGetRequireLogin', {
          path: '/api/v3/user/MYSELF/count',
          version: '1.2'
        }).then(data => {
          const { mobile, idNumber, name } = visitor
          visitor.mobile = mobile ? decrypt(mobile) : ''
          visitor.idNumber = idNumber ? decrypt(idNumber) : ''
          visitor.name = idNumber ? decrypt(name) : ''
          visitor.investCount = data.investCount
          return visitor
        })
      } else {
        return visitor
      }
    })
    .then(visitor => {
      dispatch(setVars('visitor', visitor))
      return visitor
    }).catch(()=>{
        let visitor={isLogin: false};
        dispatch(setVars('visitor', visitor))
        return visitor;
      })
}



// WEBPACK FOOTER //
// ./src/projects/fengjr/visitor.js